import { render } from "./SideBanner.vue?vue&type=template&id=34051f0b&scoped=true"
import script from "./SideBanner.vue?vue&type=script&lang=js"
export * from "./SideBanner.vue?vue&type=script&lang=js"

import "./SideBanner.vue?vue&type=style&index=0&id=34051f0b&scoped=true&lang=css"
import "./SideBanner.vue?vue&type=style&index=1&id=34051f0b&lang=css"

import exportComponent from "/Users/apple/Documents/Programing/sonak/sonak_2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34051f0b"]])

export default __exports__